import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Sale } from 'src/app/models/Sale';
import { ChartOptions, ChartType, ChartDataset } from 'chart.js';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import * as _ from 'underscore';
import { SaleService } from 'src/app/services/partner/sale.service';
@Component({
  selector: 'app-graf-skladisce-poslovalnice-stolpicni',
  templateUrl: './graf-skladisce-poslovalnice-stolpicni.component.html',
  styleUrls: ['./graf-skladisce-poslovalnice-stolpicni.component.css']
})
export class GrafSkladiscePoslovalniceStolpicniComponent implements OnInit, OnChanges {
  @Input() dataList: Array<Sale>;
  @Input() saleFilter;
  @Input() isDesktop;
  public titlesList = [];
  public titlesListSubStr = [];
  public sortedArray = [[]];
  public sortedVal = [];
  public sortedCmp = [];
  public sortedPlan = [];
  public joinedArr = [];
  public barChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      //to ne prikaže številk na grafu
      datalabels: {
          display: false,
      },
      legend: {
        display: false
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            // context.parsed.y will give you the value of the data point
            let label = context.dataset.label || '';
            let value = context.parsed.y;
            if (value >= 1000) {
              return label + ': ' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            } else {
              return label + ': ' + value.toString();
            }
          }
        }
      },
      
  },

  indexAxis: 'y', // This line makes the bar chart horizontal
  
  scales: { x: {
    ticks: {
      callback: function (value, index, values) {
        value += '';
        var x = value.toString().split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
                x1  = x1.replace(rgx, '$1' + '.' + '$2');
        }
        return x1 + x2;
      }, }
  }, y: {
    ticks : {
      autoSkip : false,
      callback : (value, index, values) => {
        if(value.toString().length > 20) {
          return value.toString().slice(0, 20) + '...';
        } else {
          return value.toString();
        }
      }
    }
  } },
  
    elements: {
      point: {
          radius: 2
      }
  }
  };
  public barChartLabels: string[] = [];
  public barChartType: ChartType = 'bar'; // Changed from 'horizontalBar' to 'bar'
  public barChartLegend = true;
  public barChartPlugins = [pluginDataLabels];
  public barChartColors: any[] = [
    { // green
      backgroundColor: 'rgb(152,251,152)',
      borderColor: 'green',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: 'rgb(152,251,152)',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    },
    { // red
      backgroundColor: 'rgba(255,0,0,0.3)',
      borderColor: 'red',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: 'rgba(255,0,0,0.3)',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    },

  ];
  public barChartData: ChartDataset[] = [
  ];
  public spinner =  true;
  constructor(private saleService: SaleService) { }

  ngOnChanges(changes: SimpleChanges): void {
    //console.log(changes);
    console.log('dela poslovalnice');
    console.log(changes);
    if(changes.saleFilter){
      if(changes.saleFilter.currentValue) {
        this.ngOnInit();
      }
    }

    if(changes.dataList.currentValue != undefined) {
      this.ngOnInit();
    }
  }

  ngOnInit() {

    this.titlesListSubStr = [];
    this.titlesList = [];
    if(this.dataList != undefined) {
      this.getTitleList();
      this.getValues();
      this.sortByValue();
      this.barChartLabels = this.joinedArr.map(val => val.title);
      if(this.isDesktop) {
        this.barChartData = [
          { data: this.joinedArr.map(val => val.sortedVal), label: 'Letos' },
          { data: this.joinedArr.map(val => val.sortedCmp), label: 'Lani' },
          { data: this.joinedArr.map(val => val.sortedPlan), label: 'Plan' }
        ];
      } else {
        this.barChartData = [
          { data: this.joinedArr.map(val => val.sortedVal), label: 'Letos' },
          { data: this.joinedArr.map(val => val.sortedCmp), label: 'Lani' }
        ];
      }

    } else {
      this.barChartLabels = [];
      this.barChartData = [];
    }

  }

  //poslovalnice
  getTitleList() {
    for(let i = 0; i < this.dataList.length; i++) {
      if(!this.titlesList.includes(this.dataList[i].title)) {
        this.titlesList.push(this.dataList[i].title);
      }
    }
    this.substringTitles();
  }

  substringTitles() {
    for(let i = 0; i < this.titlesList.length; i++) {
      this.titlesListSubStr.push(this.titlesList[i]); //.substring(0, 20) + '...'
    }
  }

  getValues() {
    this.sortedVal = [];
    this.sortedCmp = [];
    for(let j = 0; j < this.titlesList.length; j++) {
      let sumVal = 0;
      let sumValCmp = 0;
      let sumValPlan = 0;
      for(let i = 0; i < this.dataList.length; i++) {
        if(this.titlesList[j] === this.dataList[i].title) {
          if(this.saleFilter === 'SALEVALUE'){
            sumVal += this.dataList[i].saleVal;
            sumValCmp += this.dataList[i].saleValCmp;
            if(this.isDesktop) {
              sumValPlan += this.dataList[i].saleValPlan;
            }
          } else if(this.saleFilter === 'SALEVALUEWT') {
            sumVal += this.dataList[i].saleValWT;
            sumValCmp += this.dataList[i].saleValWTCmp;
            if(this.isDesktop) {
              sumValPlan += this.dataList[i].saleValWTPlan;
            }
          } else if(this.saleFilter === 'MARGINPERCENT') {
            sumVal += this.dataList[i].marginPrc;
            sumValCmp += this.dataList[i].marginPrcCmp;
            if(this.isDesktop) {
              sumValPlan += this.dataList[i].marginValPlan;
            }
          }
        }

      }
      this.sortedVal[j] = this.roundingToolNoDecimal(sumVal);
      this.sortedCmp[j] = this.roundingToolNoDecimal(sumValCmp);
      if(this.isDesktop) {
        this.sortedPlan[j] = this.roundingToolNoDecimal(sumValPlan);
      }

      sumVal = 0;
      sumValCmp = 0;
      sumValPlan = 0;
    }

  }
  roundingToolNoDecimal(num) {
    return Math.round(num);
  }

  sortByValue() {
    this.joinedArr = [];
    for (let i = 0; i < this.titlesList.length; i++) {
      if(this.isDesktop === 'true') {
      this.joinedArr.push({title: this.titlesList[i], sortedVal: this.sortedVal[i], sortedCmp: this.sortedCmp[i],
         sortedPlan: this.sortedPlan[i]});
      } else {
        this.joinedArr.push({title: this.titlesList[i], sortedVal: this.sortedVal[i], sortedCmp: this.sortedCmp[i]});
      }
    }

    this.joinedArr  = _.sortBy(this.joinedArr, 'sortedVal').reverse();
    if(this.isDesktop === 'true') {
      let deleteNum = this.joinedArr.length - this.saleService.currentSaleParametersValue.fetch;
      if(deleteNum > 0) {
        this.joinedArr.splice(this.saleService.currentSaleParametersValue.fetch, deleteNum);
      }
    }
  }

  childCaller() {
    console.log('TEST CALLER');
  }
}
